import { render } from "./BlogRightSidebar.vue?vue&type=template&id=4452bbe4"
import script from "./BlogRightSidebar.vue?vue&type=script&lang=js"
export * from "./BlogRightSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__